import {
  ScoutPrivateDocumentExtractionStatus,
  ScoutPrivateDocumentIngestionMode,
} from "generated-graphql/graphql";

export type ScoutOptimisticAttachmentPreview = {
  privateDocumentId: string;
  filename: string;
  mediaType: string;
  sizeBytes: number;
  signedDownloadUrl?: string;
  filePartUrl?: string;
  ingestionMode?: ScoutPrivateDocumentIngestionMode;
  extractionStatus?: ScoutPrivateDocumentExtractionStatus;
};

export type ScoutAttachment = {
  privateDocumentId: string;
  filename: string;
  title: string;
  mediaType: string;
  sizeBytes: number;
  signedDownloadUrl?: string;
  ingestionMode?: ScoutPrivateDocumentIngestionMode;
  extractionStatus?: ScoutPrivateDocumentExtractionStatus;
};

export function mapScoutAttachmentToPreview(
  attachment: ScoutAttachment
): ScoutOptimisticAttachmentPreview {
  return {
    privateDocumentId: attachment.privateDocumentId,
    filename: attachment.filename,
    mediaType: attachment.mediaType,
    sizeBytes: attachment.sizeBytes,
    signedDownloadUrl: attachment.signedDownloadUrl,
    ingestionMode: attachment.ingestionMode,
    extractionStatus: attachment.extractionStatus,
    filePartUrl: `encamp-private-document://${attachment.privateDocumentId}`,
  };
}
